import React from 'react';
import './MapeamentoItem.css';

const MapeamentoItem = ({ 
  mapeamento, 
  isSelected, 
  onSelect 
}) => {
  const handleClick = () => {
    onSelect(mapeamento);
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      'pending': { label: 'Pendente', className: 'status-pending' },
      'processing': { label: 'Processando', className: 'status-processing' },
      'success': { label: 'Sucesso', className: 'status-success' },
      'partial_success': { label: 'Sucesso Parcial', className: 'status-partial' },
      'error': { label: 'Erro', className: 'status-error' }
    };
    
    const config = statusConfig[status] || { label: status, className: 'status-unknown' };
    return <span className={`status-badge ${config.className}`}>{config.label}</span>;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div
      className={`mapeamento-item ${isSelected ? 'selected' : ''}`}
      onClick={handleClick}
    >
      <div className="mapeamento-content">
        <div className="mapeamento-info">
          <div className="mapeamento-header">
            <div className="mapeamento-title">
              Nota #{mapeamento.idNotaEntrada}
            </div>
            {getStatusBadge(mapeamento.status)}
          </div>
          <div className="mapeamento-meta">
            <span className="meta-item">Empresa: {mapeamento.tenantId}</span>
            <span className="meta-item">{formatDate(mapeamento.createdAt)}</span>
          </div>
          {mapeamento.errorMessage && (
            <div className="mapeamento-error">
              {mapeamento.errorMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapeamentoItem;



